const state = {
  advice: {
    modal: '', // name of the corresponding modal
    default: null, // default value of the property
    content: {
      image: null,
      alt: 'furniture_lift',
      title: 'advice.address.mm_utilisable.title', // i18n path to title
      summary: 'advice.address.mm_utilisable.summary', // i18n path to summary
    },
  },
};

const mutations = {
  SET_ADVICE(state, advice) {
    state.advice = advice;
  },
  UNSET_ADVICE(state) {
    state.advice = {
      modal: '', // name of the corresponding modal
      content: {
        image: '',
        alt: '',
        title: '', // i18n path to title
        summary: '', // i18n path to summary
      },
    };
  },
};

const getters = {
  advice: state => state.advice,
  modal: state => state.advice.modal,
  image: state => state.advice.content.image,
  alt: state => state.advice.content.alt,
  title: state => state.advice.content.title,
  summary: state => state.advice.content.summary,
};
export default {
  namespaced: true,
  state,
  mutations,
  getters,
};
